import { fetchApi } from '@/services/api';

import type { CreateScenarioPayload, Paginated, PlanningCycleRow } from '@/modules/demand-planning/types/consensus.types';

export interface ScenarioRow {
  id: number;
  name: string;
  scenario_type: string;
  status: string;
  description: string;
  planning_cycle: number;
  base_plan_version: number | null;
  parameters_json: { multiplier?: number };
  created_at: string;
}

export interface PlanVersionRow {
  id: number;
  is_current: boolean;
  version_name: string;
}

export const scenariosService = {
  list(planningCycleId?: number): Promise<ScenarioRow[]> {
    const params: Record<string, string | number> = { page_size: 500, ordering: '-created_at' };
    if (planningCycleId != null) {
      params.planning_cycle = planningCycleId;
    }
    return fetchApi<Paginated<ScenarioRow>>('demand-planning/scenarios/', { params }).then(
      (data) => data.results ?? [],
    );
  },

  listPlanningCycles(): Promise<PlanningCycleRow[]> {
    return fetchApi<Paginated<PlanningCycleRow>>('demand-planning/planning-cycles/', {
      params: { page_size: 500, ordering: '-period_start' },
    }).then((data) => data.results ?? []);
  },

  listPlanVersions(planningCycleId: number): Promise<PlanVersionRow[]> {
    return fetchApi<Paginated<PlanVersionRow>>('demand-planning/plan-versions/', {
      params: { planning_cycle: planningCycleId, page_size: 20 },
    }).then((data) => data.results ?? []);
  },

  create(payload: CreateScenarioPayload & { planning_cycle: number; base_plan_version: number }): Promise<ScenarioRow> {
    return fetchApi<ScenarioRow>('demand-planning/scenarios/', {
      method: 'POST',
      body: {
        planning_cycle: payload.planning_cycle,
        base_plan_version: payload.base_plan_version,
        name: payload.name,
        scenario_type: payload.scenario_type,
        description: payload.description ?? '',
        status: 'draft',
        parameters_json: payload.parameters_json,
      },
    });
  },
};
